import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgVerified = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M7.707 10.531a1 1 0 0 1 1.414 0l3 3 7.902-7.903a1 1 0 1 1 1.414 1.414l-8.61 8.61a1 1 0 0 1-1.414 0l-3.706-3.706a1 1 0 0 1 0-1.415"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      clipRule="evenodd"
      d="M6.263 18.512Q8.525 21.625 12 22.5q3.476-.875 5.738-3.988T20 11.6v-.345l-2.162 2.162A9.5 9.5 0 0 1 16.3 17.1q-1.7 2.475-4.3 3.3-2.6-.825-4.3-3.3T6 11.6V6.875l6-2.25 4.574 1.715 1.545-1.545L12 2.5l-8 3v6.1q0 3.8 2.264 6.912"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgVerified);
export default Memo;
